import ReactDOM from 'react-dom';
import sharedStyles from './Modals.module.css';
import styles from './ScoringModal.module.css';
import ThresholdBar from './ThresholdBar';
import { GATE_REQUIREMENTS, SCORE_REQUIREMENTS } from '../DataQAReview';

function ScoringModal({ onClose, showBackButton = false }) {
    const modal = (
        <div className={sharedStyles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className={sharedStyles.shell} role="dialog" aria-modal="true" aria-labelledby="scoring-title">
                {/* Header */}
                <div className={sharedStyles.head}>
                    <div className={sharedStyles.headInner}>
                        {showBackButton && (
                            <button className={sharedStyles.backBtn} onClick={onClose} aria-label="Go back">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Back
                            </button>
                        )}
                        <div className={sharedStyles.headLeft}>
                            <span className={sharedStyles.eyebrow}>Review &amp; Earn</span>
                            <span className={sharedStyles.titleTxt} id="scoring-title">Scoring rules</span>
                        </div>
                    </div>
                    <button className={sharedStyles.closeBtn} onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>

                {/* Scrollable content */}
                <div className={sharedStyles.scrollableContent}>
                    {/* Points per episode */}
                    <div className={sharedStyles.contentSection}>
                        <div className={sharedStyles.sectionHeader}>
                            <div className={`${sharedStyles.sectionIcon} ${sharedStyles.iconBlue}`}>
                                <svg viewBox="0 0 13 13" fill="none">
                                    <path d="M6.5 1.5l1.2 2.4 2.6.4-1.9 1.8.45 2.6L6.5 7.5 4.15 8.7l.45-2.6L2.7 4.3l2.6-.4L6.5 1.5z" stroke="#7ab3f0" strokeWidth="1.1" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span className={sharedStyles.sectionTitle}>Points per episode</span>
                        </div>
                        <div className={sharedStyles.sectionBody}>
                            <div className={sharedStyles.pointsRow}>
                                <span className={sharedStyles.pointsNumber}>100</span>
                                <span className={sharedStyles.pointsLabel}>
                                    points awarded per video scored, <strong>only when your score falls within ±15% of the final consensus score and your pass/fail checks match.</strong> Scores outside this window earn no points.
                                </span>
                            </div>
                            <ThresholdBar />
                        </div>
                    </div>

                    {/* Pass / fail criteria */}
                    <div className={sharedStyles.contentSection}>
                        <div className={sharedStyles.sectionHeader}>
                            <div className={`${sharedStyles.sectionIcon} ${sharedStyles.iconRed}`}>
                                <svg viewBox="0 0 13 13" fill="none">
                                    <path d="M2 6.5h9M7 2l4.5 4.5L7 11" stroke="#e05555" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <span className={sharedStyles.sectionTitle}>Pass / fail criteria</span>
                        </div>
                        <div className={sharedStyles.sectionBody}>
                            {GATE_REQUIREMENTS.map((item) => (
                                <div key={item.key} className={styles.passfailItem}>
                                    <div className={styles.passfailItemHeader}>
                                        <span className={styles.passfailDot} />
                                        <span className={styles.passfailName}>{item.label}</span>
                                    </div>
                                    <div className={styles.passfailDefinition}>{item.desc.definition}</div>
                                </div>
                            ))}
                            <div className={sharedStyles.infoNote}>
                                <span className={sharedStyles.infoNoteIcon}>ⓘ</span>
                                <span className={sharedStyles.infoNoteText}>
                                    A single <strong>Fail</strong> on any criterion marks the entire episode as failed. Points are only awarded on passing episodes.
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Scoring standards */}
                    {SCORE_REQUIREMENTS.map((s) => (
                        <div key={s.key} className={sharedStyles.contentSection}>
                            <div className={sharedStyles.sectionHeader}>
                                <div className={sharedStyles.sectionIcon} style={{ background: s.desc.iconBackground }}>{s.desc.icon}</div>
                                <span className={sharedStyles.sectionTitle}>{s.label}</span>
                            </div>
                            <div className={sharedStyles.sectionBody}>
                                <div className={styles.definitionRow}>
                                    <span className={styles.definitionLabel}>Definition</span>
                                    <span className={styles.definitionText}>{s.desc.definition}</span>
                                </div>
                                <div className={styles.standardsGrid}>
                                    <div className={`${styles.standardsColumn} ${styles.standardsColumnMin}`}>
                                        <div className={`${styles.standardsTag} ${styles.tagMin}`}>Minimum</div>
                                        <div className={styles.standardsText}>{s.desc.minimum}</div>
                                    </div>
                                    <div className={`${styles.standardsColumn} ${styles.standardsColumnRec}`}>
                                        <div className={`${styles.standardsTag} ${styles.tagRec}`}>Recommended</div>
                                        <div className={styles.standardsText}>{s.desc.recommended}</div>
                                    </div>
                                </div>
                                {s.desc.note && (
                                    <div className={sharedStyles.infoNote}>
                                        <span className={sharedStyles.infoNoteIcon}>ⓘ</span>
                                        <span className={sharedStyles.infoNoteText}>
                                            <strong>{s.desc.noteLabel}:</strong> {s.desc.note}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modal, document.body);
}

export default ScoringModal;
